import React,{ Component } from "react"
import {
    Modal,
    ModalHeader
} from "reactstrap";
import MapContainer from './MapContainer'
import { Button } from "@material-ui/core";



class LocationModal extends Component{
    render(){
        const {isOpen}= this.props
        const {qr} = this.props
        const {close} = this.props
    
    return(
        
             <Modal isOpen={isOpen}>
                  <ModalHeader closeButton>Last Known Location  
                      <Button  style={{marginLeft: "190px"}} variant="contained" color="primary" onClick={() => close()}>
                             Close
                         </Button>  
                  </ModalHeader>
                      {(qr.location_lat && qr.location_lon) === ""?
                      "No Location Available at this time":
                            <MapContainer
                                        lat={+qr.location_lat}
                                        long={+qr.location_lon}
                                    />
                                }
                         </Modal>

    )
                }
}
export default LocationModal;
